export default {
    methods: {
    }
}


// WEBPACK FOOTER //
// ./src/assets/mixins/AbstractTicketTypeSelect.js